module.exports = __webpack_public_path__ + "img/5-2.33580c0c.svg";